import React, { useState } from 'react';
import UserSidebar from './components/UserSidebar';
import UserTopbar from './components/UserTopbar';
import Footer from './components/Footer';
import { Routes, Route } from 'react-router-dom';
import UserDashboard from './pages/UserDashboard';
import CoursesPage from './pages/Courses/CoursesPage';
import EnrolledCoursesPage from './pages/Courses/EnrolledCoursesPage';
import CourseModulesPage from './pages/Courses/CourseModulesPage';
import SupportTicketsPage from './pages/SupportTickets/SupportTicketsPage';
import TicketDetailPage from './pages/SupportTickets/TicketDetailPage';
import UserForumList from './pages/Forums/UserForumList';
import UserForumDetail from './pages/Forums/UserForumDetail';
import MyEventCalendarPage from './pages/Calendar/MyEventCalendarPage';
import UserVltList from './pages/Vlt/UserVltList';
import MyCertificatesPage from './pages/Certificates/MyCertificatesPage';
import AvailableSurveys from './pages/Surveys/AvailableSurveys';
import TakeSurvey from './pages/Surveys/TakeSurvey';
import AvailableAssessments from './pages/Assessments/AvailableAssessments';
import TakeAssessment from './pages/Assessments/TakeAssessment';
import AssessmentResult from './pages/Assessments/AssessmentResult';
import CartPage from './pages/Cart/CartPage';
import PaymentSelectionPage from './pages/Payments/PaymentSelectionPage';
import PaymentProcessPage from './pages/Payments/PaymentProcessPage';
import PaymentSuccessPage from './pages/Payments/PaymentSuccessPage';
import PaymentFailurePage from './pages/Payments/PaymentFailurePage';
import PayPalReturnPage from './pages/Payments/PayPalReturnPage';
import PayPalCancelPage from './pages/Payments/PayPalCancelPage';
import StripeReturnPage from './pages/Payments/StripeReturnPage';
import StripeCancelPage from './pages/Payments/StripeCancelPage';
import MyTransactionsPage from './pages/Payments/MyTransactionsPage';
import UserLeaderboardPage from './pages/Gamification/LeaderboardPage';
import BadgesPage from './pages/Gamification/BadgesPage';
import MyLearningJourneys from './pages/LearningJourneys/MyLearningJourneys';
import LearningJourneyRoadmap from './pages/LearningJourneys/LearningJourneyRoadmap';
import ProfilePage from '../common/pages/ProfilePage';
import ChangePasswordPage from '../common/pages/ChangePasswordPage';
import UserTermsPage from './pages/UserTermsPage';
import UserPrivacyPage from './pages/UserPrivacyPage';
import UserFaqPage from './pages/UserFaqPage';
import { Offcanvas } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';

const UserLayout = () => {
  const [sidebarShow, setSidebarShow] = useState(false);
  const isMdUp = useMediaQuery({ minWidth: 768 });

  const handleTabChange = () => {
    setSidebarShow(false);
  };

  return (
    <>
      <div className="container-fluid vh-100 d-flex flex-row p-0 flex flex-col md:flex-row overflow-hidden">
        {/* Sidebar for md+ screens */}
        {isMdUp && (
          <div className="fixed top-0 left-0 h-full overflow-y-auto transition-transform transform -translate-x-full md:translate-x-0 md:static md:flex-shrink-0 w-full md:w-[260px] brand-app-sidebar z-50 md:z-auto">
            <UserSidebar onTabChange={handleTabChange} />
          </div>
        )}
        {/* Offcanvas Sidebar for mobile */}
        {!isMdUp && (
          <Offcanvas show={sidebarShow} onHide={() => setSidebarShow(false)} style={{ backgroundColor: '#ffffff', width: '260px' }}>
            <Offcanvas.Header closeButton style={{ borderBottomColor: '#dee2e6', backgroundColor: '#ffffff' }}>
              <Offcanvas.Title style={{ color: '#495057' }}>User Menu</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="p-0">
              <UserSidebar onTabChange={handleTabChange} />
            </Offcanvas.Body>
          </Offcanvas>
        )}
        {/* Main Content */}
        <div className="flex-grow-1 d-flex flex-column min-vh-100 flex flex-col flex-1 overflow-y-auto bg-white/90">
          <div className="border-bottom sticky top-0 z-40 items-center justify-between shadow-md">
            <UserTopbar onMenuClick={() => setSidebarShow(true)} />
          </div>
          <div className="flex-grow-1 overflow-auto p-2 flex-1 overflow-y-auto sm:p-5 md:p-2 lg:p-2">
            <Routes>
            <Route path="/dashboard" element={<UserDashboard />} />
            <Route path="/courses" element={<CoursesPage />} />
            <Route path="/enrolled-courses" element={<EnrolledCoursesPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/payment/select" element={<PaymentSelectionPage />} />
            <Route path="/payment/process" element={<PaymentProcessPage />} />
            <Route path="/payment-success" element={<PaymentSuccessPage />} />
            <Route path="/payment-failure" element={<PaymentFailurePage />} />
            <Route path="/payment/paypal/return" element={<PayPalReturnPage />} />
            <Route path="/payment/paypal/cancel" element={<PayPalCancelPage />} />
            <Route path="/payment/stripe/return" element={<StripeReturnPage />} />
            <Route path="/payment/stripe/cancel" element={<StripeCancelPage />} />
            <Route path="/transactions" element={<MyTransactionsPage />} />
            <Route path="/surveys" element={<AvailableSurveys />} />
            <Route path="/surveys/:id/respond" element={<TakeSurvey />} />
            <Route path="/assessments" element={<AvailableAssessments />} />
            <Route path="/assessments/:id" element={<TakeAssessment />} />
            <Route path="/assessments/:id/result" element={<AssessmentResult />} />
            <Route path="/calendar" element={<MyEventCalendarPage />} />
            <Route path="/course-modules/:courseId" element={<CourseModulesPage />} />
            <Route path="/support-tickets" element={<SupportTicketsPage />} />
            <Route path="/support-tickets/:id" element={<TicketDetailPage />} />
            <Route path="/forums" element={<UserForumList />} />
            <Route path="/forums/:id" element={<UserForumDetail />} />
            <Route path="/vlt" element={<UserVltList />} />
            <Route path="/certificates" element={<MyCertificatesPage />} />
            <Route path="/leaderboard" element={<UserLeaderboardPage />} />
            <Route path="/badges" element={<BadgesPage />} />
            <Route path="/learning-journeys" element={<MyLearningJourneys />} />
            <Route path="/learning-journeys/:id" element={<LearningJourneyRoadmap />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/change-password" element={<ChangePasswordPage />} />
            <Route path="/terms" element={<UserTermsPage />} />
            <Route path="/privacy" element={<UserPrivacyPage />} />
            <Route path="/faqs" element={<UserFaqPage />} />
            <Route path="/" element={<UserDashboard />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default UserLayout;